import { keyframes } from '@emotion/core';
import styled from '@emotion/styled';
import { Box, Flex } from '@rebass/emotion';
import theme from '../../styles/theme';
import { rem } from '../../styles/theme/layout';
import { ratioToPercentage } from '../../styles/utils';

const openAnimation = keyframes`
  0% {opacity: 0; transform: scale(0.2);}
  100% {opacity: 1; transform: scale(1); }
`;

export const Overlay = styled(Flex)`
  position: fixed;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.95);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow: hidden;
  justify-content: center;
  align-items: center;
  animation: ${openAnimation} 0.4s;
`;

export const Wrapper = styled(Box)`
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding: 10%;
`;

export const RatioBox = styled(Box)`
  padding-top: ${ratioToPercentage([645, 363])};
  overflow: hidden;
  height: 0;
  position: relative;
`;

export const EmbedVideo = styled.iframe`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: ${theme.space[3]};
  right: ${theme.space[3]};
  background: none;
  border: 0;
  font-size: ${rem(28)};
  color: ${theme.colors.white};
  cursor: pointer;
`;

export default { Overlay, Wrapper, RatioBox, CloseButton, EmbedVideo };
